<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">

    <span class="panel-title" *ngIf="!agreementId"> {{'app.create' | translate}}</span>
    <span class="panel-title" *ngIf="agreementId"> {{'app.edit' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="container text-center" *ngIf="displayMode==1">
        <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
      </div>
      <form #f="ngForm" *ngIf="displayMode==2"
            novalidate (ngSubmit)="save(f)">
        <div class="row padding-sm-vr">
          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (targetQuantity.dirty || targetQuantity.touched || f.submitted)  && targetQuantity.valid, 'has-error' : (targetQuantity.dirty || targetQuantity.touched || f.submitted)  && targetQuantity.invalid}">
              <label class="control-label">{{'Target Quantity' | translate}} </label>
              <input type="number"
                     name="targetQuantity"  required
                     [(ngModel)]="agreement.targetQuantity"
                     #targetQuantity="ngModel" min="1"
                     class="form-control" />
              <div *ngIf="(targetQuantity.dirty || targetQuantity.touched || f.submitted)  && targetQuantity.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (targetValue.dirty || targetValue.touched || f.submitted)  && targetValue.valid, 'has-error' : (targetValue.dirty || targetValue.touched || f.submitted)  && targetValue.invalid}">
              <label class="control-label">{{'Target Value' | translate}} </label>
              <input type="number"
                     name="targetValue"  required
                     [(ngModel)]="agreement.targetValue"
                     #targetValue="ngModel" min="1"
                     class="form-control" />
              <div *ngIf="(targetValue.dirty || targetValue.touched || f.submitted)  && targetValue.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (brandId.dirty || brandId.touched || f.submitted)  && brandId.valid, 'has-error' : (brandId.dirty || brandId.touched || f.submitted)  && brandId.invalid}">
              <label class="control-label" for="brandId-{{uniqueId}}">{{'representation.itemsBrands' | translate}}</label>
              <span class="ui-fluid">
                <p-dropdown [options]="itemBrands"
                            styleClass="wid100"
                            placeholder="Item Brands" required
                            emptyFilterMessage="No results found"
                            showClear="true"
                            name="brandId" #brandId="ngModel"
                            [(ngModel)]="agreement.itemBrand" (onChange)="onSelectItemBrand(agreement)"
                            [filter]="true" optionLabel="name"></p-dropdown>
              </span>
              <div *ngIf="(brandId.dirty || brandId.touched || f.submitted)  && brandId.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (itemId.dirty || itemId.touched || f.submitted)  && itemId.valid, 'has-error' : (itemId.dirty || itemId.touched || f.submitted)  && itemId.invalid}">
              <label class="control-label" for="itemId-{{uniqueId}}">{{'Items' | translate}}</label>
              <span class="ui-fluid">
                <p-dropdown [options]="itemsFiltered"
                            styleClass="wid100"
                            placeholder="Items"  required
                            emptyFilterMessage="No results found"
                            showClear="true"
                            name="itemId" #itemId="ngModel"
                            [(ngModel)]="agreement.item"
                            [filter]="true" optionLabel="name"></p-dropdown>
              </span>
              <div *ngIf="(itemId.dirty || itemId.touched || f.submitted)  && itemId.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (hcpId.dirty || hcpId.touched || f.submitted)  && hcpId.valid, 'has-error' : (hcpId.dirty || hcpId.touched || f.submitted)  && hcpId.invalid}">
              <label class="control-label" for="hcpId-{{uniqueId}}">{{'HCPs' | translate}}</label>
              <span class="ui-fluid">
                <p-dropdown [options]="hcps"
                            styleClass="wid100"
                            placeholder="hcps"  required
                            emptyFilterMessage="No results found"
                            showClear="true"
                            name="hcpId" #hcpId="ngModel"
                            [(ngModel)]="agreement.hcp"
                            [filter]="true" optionLabel="fullName"></p-dropdown>
              </span>
              <div *ngIf="(hcpId.dirty || hcpId.touched || f.submitted)  && hcpId.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (date.dirty || date.touched || f.submitted)  && date.valid, 'has-error' : (date.dirty || date.touched || f.submitted)  && date.invalid}">
              <label class="control-label">{{'Date' | translate}} </label>
              <div class="input-group date">
                <input class="form-control" placeholder="yyyy-mm-dd" required
                       name="date" #date="ngModel"
                       [(ngModel)]="agreementDate" ngbDatepicker #dpYMD="ngbDatepicker">
                <span class="input-group-btn date-label">
                  <button class="btn date-btn" (click)="dpYMD.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                </span>


              </div>
              <div *ngIf="(date.dirty || date.touched || f.submitted)  && date.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>

        </div>

        <div class="panel-footer margin-left-20 margin-top-20 margin-left-37">
          <button class="btn  btn-cancel" type="button" (click)="back()">{{'app.cancel' | translate}}</button>&nbsp;
          <button class="btn  btn-save" type="submit" [disabled]="f.invalid">{{'app.save' | translate}}</button>

        </div>

      </form>
    </div>
  </div>
</div>

<div class="row col-sm-12 padding-sm-hr" *ngIf="displayMode==3">
  <div class="alert alert-danger alert-dark">
    <button type="button" class="close" data-dismiss="alert">×</button>
    {{'app.ServerError' |translate}}.
  </div>
</div>




